<template>

    <div class="px-6 py-4 bg-minplan-beige -mb-4">
        <page-title :title="$t('apartments.editBuyer')"></page-title>
    </div>

    <jet-form-section @submitted="editBuyer()">

        <template #form>

            <!-- Card Apartment Information -->
            <form-card :title="$t('apartments.buyer')" :description="$t('apartments.buyerDescription')">
                <!-- Zwei verschiedene Fragen, deshalb zwei Eigenschaften:
                     `invited` blendet den Einladen-Schalter aus (zu DIESER
                     Wohnung ging schon eine Einladung hinaus, Spec §3b),
                     `email-required` setzt den Stern an die E-Mail. Der
                     Käufer mit Konto aus einer ANDEREN Wohnung trennt die
                     beiden: er lässt sich hier noch einladen, seine E-Mail
                     ist aber schon Pflicht (Anmeldung). -->
                <BuyerFormFields :form="form" mode="edit" :invited="!!buyer.invited"
                                 :email-required="!!buyer.emailRequired" />
            </form-card>
        </template>

        <template #actions>
            <div class="flex justify-end my-4 mx-6">

                <button @click="cancel" type="button" class="inline-block uppercase font-semibold text-xs tracking-widest">
                    {{ $t("actions.cancel") }}
                </button>

                <primary-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="ml-3 ">
                    {{ $t("actions.save") }}
                </primary-button>

            </div>
        </template>

    </jet-form-section>

</template>


<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetFormSection from "@/Jetstream/FormSection";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import PageTitle from "@/Shared/Components/PageTitle";
import { useForm } from "@inertiajs/inertia-vue3";
import FormCard from "@/Shared/Components/FormCard";
import BuyerFormFields from "@/Shared/Components/Buyers/BuyerFormFields.vue";

export default defineComponent({
    props: ["buyer", "apartment"],
    inheritAttrs: false,
    layout: MainLayout,
    emits: ["closeModal"],
    components: {
        PageTitle,
        PrimaryButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        FormCard,
        BuyerFormFields
    },
    methods: {
        cancel() {
            this.$emit("closeModal");
        },
        editBuyer() {
            this.form.put(this.route("advisors.apartments.update.buyer", {apartment: this.apartment.uuid, buyer: this.buyer.id}), {
                preserveScroll: true,
                onSuccess: () => this.$notify({
                    group: "success",
                    title: 'actions.success',
                    text: 'apartments.buyerUpdated'
                })
            });
        }
    },
    setup(props) {


        const form = useForm({
            firstname: props.buyer.firstname,
            lastname: props.buyer.lastname,
            street: props.buyer.street,
            zip: props.buyer.zip,
            city: props.buyer.city,
            phone: props.buyer.phone,
            email: props.buyer.email,
            notify: props.buyer.notify,
            country: props.buyer.country,
            // Einladen aus dem Bearbeiten heraus (Entscheid Peter, 22.09.2026).
            invite: false
        });

        return { form };
    }
});
</script>

<style scoped></style>
